module.exports = __webpack_public_path__ + "assets/menu-mini.68bbb781.svg";